import { createContext, useContext } from "react";

import type { DetailedCampaign } from "../types";

const CampaignContext = createContext<DetailedCampaign>(null);

export const CampaignProvider = CampaignContext.Provider;

export function useCampaignContext() {
  return useContext(CampaignContext);
}
